export abstract class Type {
  name: string;
}
